import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "lucide-react";

const colorClasses = {
  emerald: { 
    border: "border-emerald-500", 
    bg: "bg-emerald-50", 
    text: "text-emerald-700", 
    badgeBg: "bg-emerald-600", 
    check: "text-emerald-500" 
  },
  blue: { 
    border: "border-blue-500", 
    bg: "bg-blue-50", 
    text: "text-blue-700", 
    badgeBg: "bg-blue-600", 
    check: "text-blue-500" 
  },
  purple: { 
    border: "border-purple-500", 
    bg: "bg-purple-50", 
    text: "text-purple-700", 
    badgeBg: "bg-purple-600", 
    check: "text-purple-500" 
  }
};

export function PlanCard({ planId, planName, price, color, currentPlan, badge, features, onSelect }) {
  const isCurrentPlan = currentPlan === planId;
  const c = colorClasses[color];

  return (
    <div 
      className={`border-2 rounded-lg p-6 relative transition-all cursor-pointer hover:shadow-lg ${
        isCurrentPlan ? `${c.border} ${c.bg}` : `border-gray-200 hover:${c.border.replace('border-', 'border-')}`
      }`}
      onClick={onSelect}
      data-testid={`plan-${planId}`}
    >
      {!isCurrentPlan && badge && (
        <span className={`absolute -top-3 left-1/2 -translate-x-1/2 ${c.badgeBg} text-white text-xs px-3 py-1 rounded-full`}>
          {badge}
        </span>
      )}
      {isCurrentPlan && (
        <span className={`inline-block ${c.badgeBg} text-white text-xs px-2 py-1 rounded-full mb-2`}>
          CURRENT PLAN
        </span>
      )}
      <h3 className={`font-bold text-lg ${c.text}`}>{planName}</h3>
      <p className="text-3xl font-bold mt-2">
        ₹{price}
        <span className="text-sm font-normal text-gray-500">/subject/month</span>
      </p>
      <ul className="mt-4 space-y-2 text-sm text-gray-600">
        {features.map((feature, idx) => (
          <li key={idx} className={`flex items-center gap-2 ${!feature.included ? 'text-gray-400' : ''}`}>
            {feature.included ? (
              <CheckCircle className={`h-4 w-4 ${c.check}`} />
            ) : (
              <XCircle className="h-4 w-4" />
            )}
            {feature.bold ? <strong>{feature.text}</strong> : feature.text}
          </li>
        ))}
      </ul>
      <Button 
        className={`w-full mt-4 ${!isCurrentPlan ? `${c.badgeBg.replace('bg-', 'bg-')} hover:opacity-90` : ""}`}
        variant={isCurrentPlan ? "secondary" : "default"}
        disabled={isCurrentPlan}
        data-testid={`select-${planId}-btn`}
      >
        {isCurrentPlan ? "Current Plan" : planId === "pro" ? "Go Pro" : `Select ${planName}`}
      </Button>
    </div>
  );
}

export default PlanCard;
